// extracted by mini-css-extract-plugin
export default {"main":"quest_main__h5+JW","box":"quest_box__EJLMp"};